export default __webpack_public_path__ + "static/media/AdobeStock_222880408 (1).b2e8d1d2.png";